import type { TFunction } from 'i18next';
import type { Dokumenttype, Plandokument, PlandokumentInput } from '@origo/planregister';
import type { DocumentFormValues, DocumentItem } from '../types';
import { dokumenttypeLabel } from '../codelists/dokumenttype';
import { parseIsoDate } from './toProcessings';

const norwegianDateFormat = new Intl.DateTimeFormat('nb-NO', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
});

export function toDocumentItem(doc: Plandokument, t: TFunction): DocumentItem {
    return {
        id: doc.dokumentId,
        dokumentnavn: doc.tittel,
        dokumenttype: dokumenttypeLabel(doc.dokumenttype, t),
        dato: doc.dokumentdato ? norwegianDateFormat.format(doc.dokumentdato) : undefined,
        url: doc.referansedokumentfil,
    };
}

export function emptyDocumentForm(): DocumentFormValues {
    return { tittel: '', dokumenttype: '', dato: '', beskrivelse: '' };
}

export function toPlandokumentInput(values: DocumentFormValues, napId: string): PlandokumentInput {
    return {
        dokumentId: crypto.randomUUID(),
        nasjonalArealplanId: napId,
        tittel: values.tittel,
        dokumenttype: (values.dokumenttype || undefined) as Dokumenttype | undefined,
        dokumentdato: parseIsoDate(values.dato),
        beskrivelse: values.beskrivelse || undefined,
    };
}
